import { tap } from 'rxjs/operators';
import { Observable } from 'rxjs';
import { ProcessType } from "../../types";

export const G =  (global as any);

export type ServicesType = ProcessType;

export const COLOR_OPTIONS = [
    '#6285FF',
    '#2952E1',
    '#00A396',
    '#1A7871',
    '#FFCA3A',
    '#F24E1E',
    '#FB5879',
    '#BB2F4B',
    '#996EE2',
    '#6337AE',
    '#181818',
    '#6042f5',
    '#00f0d8'
];

const typeColor = {
    [ProcessType.ARC]: COLOR_OPTIONS[0],
    [ProcessType.ADC]: COLOR_OPTIONS[1],
    [ProcessType.CDS]: COLOR_OPTIONS[2],
    [ProcessType.MLC]: COLOR_OPTIONS[3],
    [ProcessType.AWRC]: COLOR_OPTIONS[4],
    [ProcessType.ALARM]: COLOR_OPTIONS[5],
    [ProcessType.HEALTHCHECK]: COLOR_OPTIONS[6],
    [ProcessType.WINCC]: COLOR_OPTIONS[7],
    [ProcessType.BAL]: COLOR_OPTIONS[8],
    [ProcessType.ACKNOWLEDGE]: COLOR_OPTIONS[9],
    [ProcessType.CONFIG]: COLOR_OPTIONS[10],
};

const setDefulatGlobalVar = () => {
    Object.keys(ProcessType).forEach(name => {
        G[`SHOW_${name}_LOGS`] = false;
    })
};
setDefulatGlobalVar();

export const logger = (data: unknown, type: ServicesType, optionalText = '', isInitial: boolean = false) => {
    if(G[`SHOW_${type}_LOGS`]){
        console.log(`%c ${optionalText} ${type}${isInitial ? ' INITIAL' : ''}: `, `color: ${typeColor[type]}; font-weight: bold;`, data  )
    }
};

export const withLogger = <T>(o: Observable<T>, type: ServicesType, options: {optionalText?:string, isInitial?: boolean} = {}) => {
    return o.pipe(tap(data => logger(data, type, options.optionalText, options.isInitial)))
}